import React from "react";
import { IMediaToolkitNavPage } from "../models/IMediaToolkit";

export interface ITutorialPageProps extends IMediaToolkitNavPage {
    videoUrl: string;
}

export const TutorialPage: React.FunctionComponent<ITutorialPageProps> = (props) => {
    return (
        <>
            <div className="card-header bg-aap-creamy-gray-500 text-aap-dk-red-500 px-5 xl:px-10 py-5 pt-10">
                <div>
                    <h1 className="text-4xl mb-5">{props.title}</h1>
                    <div className="text-sm" dangerouslySetInnerHTML={{ __html: props.description }}></div>
                </div>
            </div>
            <div className="card-body bg-aap-cream-500 p-5 pt-0 xl:p-10 xl:pt-0">
                {props.ctaMap}
                <div className="w-full max-w-xl mx-auto">
                    <iframe
                        className="w-full aspect-video"
                        src={props.videoUrl}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                {props.footer ? (
                    <div className="pt-10">
                        <div dangerouslySetInnerHTML={{ __html: props.footer || "" }}></div>
                    </div>
                ) : null}
                <div className="mobileNav py-2 flex justify-between lg:hidden">
                    {props.backButton}
                    {props.continueButton}
                </div>
            </div>
        </>
    );
};
